function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import normalizeLocaleData from '../../../../utils/i18n/normalizeLocaleData';
import AdditionalIntl from '../../../../I18n/AdditionalIntl/AdditionalIntl';
import I18n from '../../../../I18n/I18n/I18n';
import en from './locales/DeleteModal.en.json';
import Modal from '../../../../Modal/Modal/Modal';
import ModalBody from '../../../../Modal/ModalBody/ModalBody';
import ModalFooter from '../../../../Modal/ModalFooter/ModalFooter';
import Button from '../../../../Buttons/Button/Button';
import ButtonLabel from '../../../../Buttons/ButtonLabel/ButtonLabel';
import ButtonGroup from '../../../../Buttons/ButtonGroup/ButtonGroup';
var DeleteModal = /*#__PURE__*/function (_React$Component) {
  _inherits(DeleteModal, _React$Component);
  function DeleteModal(props) {
    var _this;
    _classCallCheck(this, DeleteModal);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DeleteModal).call(this, props));
    _this.messages = void 0;
    _this.messages = normalizeLocaleData(en, '@dm/components.deleteModal');
    return _this;
  }
  _createClass(DeleteModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AdditionalIntl, {
        messages: this.messages,
        namespace: "@dm/components.deleteModal"
      }, /*#__PURE__*/React.createElement(Modal, {
        refocusEl: this.props.refocusEl,
        className: "_dm-form-dsa-remove-modal",
        mounted: this.props.isShowing,
        titleText: '@dm/components.deleteModal.title',
        onExit: this.props.onCancel,
        includeCloseX: false
      }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(I18n, {
        i18n: '@dm/components.deleteModal.message'
      })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
        className: "_dm-button",
        onClick: this.props.onCancel
      }, /*#__PURE__*/React.createElement(ButtonLabel, {
        i18nKey: "@dm/components.deleteModal.cancel"
      })), /*#__PURE__*/React.createElement(Button, {
        className: "_dm-button",
        modifier: "delete",
        onClick: this.props.onDelete
      }, /*#__PURE__*/React.createElement(ButtonLabel, {
        i18nKey: "@dm/components.deleteModal.confirm"
      }))))));
    }
  }]);
  return DeleteModal;
}(React.Component);
export { DeleteModal as default };